/**
 * @jest-environment jsdom
 */
import {createSelector} from 'reselect';
import {initialState} from './reducer';

const selectState = (state) => state.OFFER_DISPLAY || initialState;

const selectInitializing = () =>
    createSelector(
        selectState,
        state => state.initializing,
    );

const selectError = () =>
    createSelector(
        selectState,
        state => state.error,
    );

const selectUpdating = () =>
    createSelector(
        selectState,
        state => state.updating,
    );

const selectCurrentOffers = () =>
    createSelector(
        selectState,
        state => state.currentOffers,
    );

const selectIsDefault = () =>
    createSelector(
        selectState,
        state => state.isDefault,
    );

const selectAdditionalContentDownloaded = () =>
    createSelector(
        selectState,
        state => state.additionalContentDownloaded,
    );

export {
    selectInitializing,
    selectError,
    selectUpdating,
    selectCurrentOffers,
    selectIsDefault,
    selectAdditionalContentDownloaded,
};
